<template>
  <UIDrawer
    :is-open
    :z-index
    size="lg"
    title="JSON data"
    @close="handleClose"
  >
    <UIJsonTree
      :json
      size="sm"
      class="mapping-rules-json-modal"
      @click:node="handleClickNode"
    />
  </UIDrawer>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { ModalClass } from '@types'

import { useHotKeys } from '@/plugins/hotKeys'

import { UIJsonTree } from '@ui/core'
import { UIDrawer } from '@ui/modals'

type Props = {
  modal: ModalClass<any>
  json: Record<string, unknown>
}

type Emits = {
  click: [path: string[]]
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()

const isOpen = computed(() => props.modal.isOpened)
const zIndex = computed(() => props.modal.zIndex)

const handleClose = () => {
  props.modal.close()
}

const handleClickNode = (path: string[]) => {
  props.modal.close()
  emit('click', path)
}

useHotKeys(
  'escape',
  e => {
    e?.stopPropagation()
    if (!isOpen.value) return
    handleClose()
  }, { flag: isOpen },
)
</script>

<style>
.mapping-rules-json-modal {
  .ui-tree__item {
    @apply cursor-pointer;
  }
}
</style>
